import React from "react"
import Video from "../components/Video"
import VideoMobile from "../components/VideoMobile"

export default function VacheronPage(props) {
  return (
    <div id="vacheron-constantin-the-quest">
      <VideoMobile
        title="Vacheron Constantin, The Quest • Directed by Arnaud Bressond"
        src="https://player.vimeo.com/video/1089637502?title=0&muted=0"
        allowsInlineMediaPlayback="true"
      />
      <Video
        title="Vacheron Constantin, The Quest • Directed by Arnaud Bresson"
        src="https://player.vimeo.com/video/1089637502?background=1&autoplay=1&loop=1&byline=0&title=0&muted=0"
      />
    </div>
  )
}
